export default {
    aboutUsTitle1: "关于我们",
   
    aboutUsContent1: "Seederindonesia隶属于PT JAYA TEKNOLOGI SUKSES（JTS，成立于2019年），是一家数据驱动的科技公司，利用银行、电商、通讯、消费等合规企业提供的关于用户的日常行为数据，通过大数据挖掘、人工智能等技术，构建多维度用户画像。为互联网金融公司、银行、保险等企业等提供如信用评分、黑名单等数据高品质的数据和科技服务。",
};